import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {TimerOutlined as TimerOutlinedIcon} from 'views/icons';
import {translate} from 'views/module';

import {DraftTextField} from '../AgentJobDraftFields';

const TimerAgentJobDraft = (props) => {
  const {
    draftPayload,
    updatePayloadField,
  } = props;

  return (
    <Stack sx={{gap: 1.25}}>
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Message')}
        multiline
        onChange={updatePayloadField('message')}
        value={draftPayload.message}
      />
    </Stack>
  );
};

TimerAgentJobDraft.propTypes = {
  draftPayload: PropTypes.object.isRequired,
  updatePayloadField: PropTypes.func.isRequired,
};

const buildPayload = ({draftPayload}) => draftPayload;

const getDraftBody = (job) => job.actionPayload?.message || '';

const getDraftTitle = () => translate('case.Detail.AgentJobs.TimerTitle');

const getDraftSubtitle = () => translate('case.Detail.AgentJobs.ActionLabels.Timer');

const getListDetail = (job, participantDetails, executeAtLabel) => {
  return job.actionPayload?.message || executeAtLabel;
};

export default {
  Draft: React.memo(TimerAgentJobDraft),
  DraftIcon: TimerOutlinedIcon,
  actionType: 'TIMER',
  buildPayload,
  getDraftBody,
  getDraftSubtitle,
  getDraftTitle,
  getListDetail,
  label: translate('case.Detail.AgentJobs.ActionLabels.Timer'),
};
